import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=4899a09c&scoped=true"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=4899a09c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4899a09c",
  null
  
)

export default component.exports